import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { isEqual } from "lodash";
import { StrategyImport } from "../../../types/imports";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement);

function VCarTrace() {
  const strategyImport: StrategyImport | null = useSelector(
    (state: RootState) => state.imports?.importPreviews?.strategy,
    isEqual,
  );

  const { chartData, xMax } = useMemo(() => {
    if (!strategyImport?.data || !strategyImport.data.refLapData) {
      return {
        chartData: { labels: [], datasets: [] },
        xMax: 1,
      };
    }

    const refLapDistance = strategyImport.data.refLapData[3];
    const refLapTime = strategyImport.data.refLapData[2];
    const vCar: { x: number; y: number }[] = [];

    for (let i = 1; i < refLapDistance.length; i++) {
      const distance = refLapDistance[i] - refLapDistance[i - 1];
      const time = refLapTime[i] - refLapTime[i - 1];
      vCar.push({
        x: refLapTime[i],
        y: (distance / time) * 3.6,
      });
    }

    // Calculate min and max values for x-axis range
    const xValues = vCar.map((point) => point.x);
    const xMaxVal = xValues.length > 0 ? Math.max(...xValues) : 1;

    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: "vCar (km/h)",
            data: vCar,
            pointRadius: 0,
            borderColor: "#A18B6B",
            borderWidth: 2,
          },
        ],
      },
      xMax: xMaxVal,
    };
  }, [strategyImport]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        color: "#ffffff",
        text: "vCar",
      },
    },
    scales: {
      x: {
        type: "linear" as const,
        min: 0,
        max: xMax,
        border: {
          color: "#ffffff",
        },
        grid: {
          display: false,
          color: "#505050",
        },
        ticks: {
          display: true,
          color: "#ffffff",
          stepSize: 10,
        },
        title: {
          display: true,
          text: "tLap (s)",
          color: "#ffffff",
        },
      },
      y: {
        grid: {
          color: "#505050",
        },
        ticks: {
          color: "#ffffff",
        },
        border: {
          color: "#ffffff",
        },
        title: {
          display: true,
          text: "vCar (km/h)",
          color: "#ffffff",
        },
      },
    },
  };

  return (
    <div className={styles.container}>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
}

export default VCarTrace;
